import React from "react";
import { Box, Typography, Divider, Pagination, colors, Skeleton } from "@mui/material";
import { CardsWrapper } from "./styles";

import { ORDER_TYPE, PLAN_NAMES } from "../../../../constants";

import { formatDate } from "../../../../utils/formatDate";

import { INVITATION_ORDER_STATUSES_ENUM, Order } from "../../../../store/services/orders/dto/orders.dto";
import { formatCurrency } from "../../../../utils/formatCurrency";
import { StyleCircle } from "../../../../Components/Inputs/Settings/styles";

const ORDER_STATUS_COLOR: Record<INVITATION_ORDER_STATUSES_ENUM, string> = {
	[INVITATION_ORDER_STATUSES_ENUM.PENDING]: colors.orange[500],
	[INVITATION_ORDER_STATUSES_ENUM.COMPLETED]: colors.green[500],
	[INVITATION_ORDER_STATUSES_ENUM.FAILED]: colors.yellow[500],
	[INVITATION_ORDER_STATUSES_ENUM.CANCELLED]: colors.green[500]
};

const OrderCardSkeleton = () => (
	<Box className={"card"}>
		<Box my={1} display={"flex"} justifyContent={"space-between"} alignItems={"center"} px={1}>
			<Skeleton width={160} height={20} />
			<Skeleton width={80} height={20} />
		</Box>
		<Divider />
		<Box p={1} pb={0} display={"flex"} flexDirection={"column"} gap={1}>
			<Box display={"flex"} justifyContent={"space-between"}>
				<Skeleton width={80} height={40} />
				<Skeleton width={80} height={40} />
			</Box>
			<Divider />
			<Skeleton width={"70%"} height={20} />
			<Divider />
			<Skeleton width={100} height={20} />
		</Box>
	</Box>
);
const OrdersCardsList = ({
	data,
	page,
	perPage,
	totalItems,
	onPageChange,
	isLoading
}: {
	data: Order[];
	page: number;
	perPage: number;
	totalItems: number;
	onPageChange: (page: number) => void;
	isLoading?: boolean;
}) => {
	if (isLoading) {
		return (
			<CardsWrapper>
				{Array.from({ length: 4 }).map((_, i) => (
					<OrderCardSkeleton key={i} />
				))}
			</CardsWrapper>
		);
	}

	return (
		<CardsWrapper>
			{(data || []).map(item => (
				<Box key={item.user_id} className={"card"}>
					<Box my={1} display={"flex"} justifyContent={"space-between"} alignItems={"center"} px={1}>
						<Typography fontWeight={"bold"}>order id: {item.orderId}</Typography>
						<Box display={"flex"} gap={1} alignItems={"center"}>
							<StyleCircle $color={ORDER_STATUS_COLOR[item.status || 1]} />
							<Typography variant={"caption"}>{ORDER_TYPE[item.status]}</Typography>
						</Box>
					</Box>
					<Divider />
					<Box p={1} pb={0} display={"flex"} flexDirection={"column"} gap={1}>
						<Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
							<Box display={"flex"} flexDirection={"column"} alignItems={"flex-start"} gap={1}>
								<Typography fontWeight={"bold"}>plan</Typography>
								<Typography>{PLAN_NAMES[item.planId]}</Typography>
							</Box>
							<Box display={"flex"} flexDirection={"column"} alignItems={"flex-start"} gap={1}>
								<Typography fontWeight={"bold"}>amount</Typography>
								<Typography>{formatCurrency(item.amount, item.currency)}</Typography>
							</Box>
						</Box>
						<Divider />
						<Box display={"flex"} flexDirection={"column"}>
							<Typography>Invitation Id:</Typography>
							<Box display={"flex"} gap={1}>
								<Typography>{item.invitation_id}</Typography>
							</Box>
						</Box>
						<Divider />
						<Box className={"card-footer"}>
							<Typography>{formatDate(item.createdAt)}</Typography>
						</Box>
					</Box>
				</Box>
			))}
			{!!(page && perPage && totalItems) && (
				<Box p={2} display={"flex"} justifyContent={"flex-end"}>
					<Pagination
						page={page}
						count={Math.ceil(totalItems / perPage)}
						shape="rounded"
						onChange={(event: unknown, newPage: number) => {
							onPageChange(newPage);
						}}
					/>
				</Box>
			)}
		</CardsWrapper>
	);
};

export default OrdersCardsList;
